"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contains = contains;
exports.containsEvery = containsEvery;
exports.every = every;
exports.find = find;
exports.findFirst = findFirst;
exports.findFirstIndex = findFirstIndex;
exports.findLast = findLast;
exports.findLastIndex = findLastIndex;
exports.fold = fold;
exports.fromTo = fromTo;
exports.generate = generate;
exports.map = map;
exports.reduce = reduce;
exports.repeat = repeat;
exports.some = some;
exports.step = step;
exports.take = take;
exports.takeFirst = takeFirst;
exports.takeLast = takeLast;
exports.toObject = toObject;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _marked = /*#__PURE__*/_regenerator.default.mark(generate),
    _marked2 = /*#__PURE__*/_regenerator.default.mark(fromTo),
    _marked3 = /*#__PURE__*/_regenerator.default.mark(repeat),
    _marked4 = /*#__PURE__*/_regenerator.default.mark(step),
    _marked5 = /*#__PURE__*/_regenerator.default.mark(find),
    _marked6 = /*#__PURE__*/_regenerator.default.mark(map),
    _marked7 = /*#__PURE__*/_regenerator.default.mark(reduce);

/**
 * 生成0,1,2...序列
 * @export
 * @param {Number} start 起始值
 * @returns {Iterable<Number>} 生成器
 *
 */
function generate() {
  var start,
      _args = arguments;
  return _regenerator.default.wrap(function generate$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          start = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;

        case 1:
          if (!true) {
            _context.next = 6;
            break;
          }

          _context.next = 4;
          return start++;

        case 4:
          _context.next = 1;
          break;

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * 生成从from到to的序列
 * @export
 * @param {Number} from 起始值
 * @param {Number} to 终点值
 * @param {Number} [step=1] 步长
 * @returns {Iterable<Number>} 生成器
 *
 */
// eslint-disable-next-line no-shadow


function fromTo(from, to) {
  var step,
      _args2 = arguments;
  return _regenerator.default.wrap(function fromTo$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          step = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 1;

        case 1:
          if (!(step > 0 ? from < to : from > to)) {
            _context2.next = 7;
            break;
          }

          _context2.next = 4;
          return from;

        case 4:
          from += step;
          _context2.next = 1;
          break;

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 *
 * 生成重复的对象
 * @export
 * @param {*} obj 需要重复的对象
 * @returns {Iterable<*>} 生成器
 */


function repeat(obj) {
  return _regenerator.default.wrap(function repeat$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!true) {
            _context3.next = 5;
            break;
          }

          _context3.next = 3;
          return obj;

        case 3:
          _context3.next = 0;
          break;

        case 5:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/**
 *
 * 根据起始和补偿生成序列，如1,3,5,7,9
 * @export
 * @param {Number} [start=0]
 * @param {Number} [step=1]
 * @returns {Iterable<Number>} 生成器
 */
// eslint-disable-next-line no-shadow


function step() {
  var start,
      step,
      _args4 = arguments;
  return _regenerator.default.wrap(function step$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          start = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : 0;
          step = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 1;

        case 2:
          _context4.next = 4;
          return start;

        case 4:
          start += step;
          _context4.next = 2;
          break;

        case 7:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 *
 * 取生成器生成的前n个元素组成的数组
 * @export
 * @param {Number} n
 * @param {Iterable<T>} iterator
 * @returns {Array<T>} 数组
 *
 * @example
 * take(5, generate()); // [0,1,2,3,4]
 * take(5, repeat(1)); // [1,1,1,1,1]
 * take(5, step(1, 2)); // [1,3,5,7,9]
 */


function take(n, iterator) {
  var i = 0;
  var result = [];

  var _iterator = _createForOfIteratorHelper(iterator),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;

      if (i++ < n) {
        result.push(item);
      } else {
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}
/**
 *
 * 寻找一个迭代器中符合条件的项
 * @export
 * @param {Generator} iterator 迭代器
 * @param {Function} callback 回调
 * @returns {Generator} 符合条件的项组成的迭代器
 */


function find(iterator, callback) {
  var _iterator2, _step2, item;

  return _regenerator.default.wrap(function find$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _iterator2 = _createForOfIteratorHelper(iterator);
          _context5.prev = 1;

          _iterator2.s();

        case 3:
          if ((_step2 = _iterator2.n()).done) {
            _context5.next = 10;
            break;
          }

          item = _step2.value;

          if (!callback(item)) {
            _context5.next = 8;
            break;
          }

          _context5.next = 8;
          return item;

        case 8:
          _context5.next = 3;
          break;

        case 10:
          _context5.next = 15;
          break;

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](1);

          _iterator2.e(_context5.t0);

        case 15:
          _context5.prev = 15;

          _iterator2.f();

          return _context5.finish(15);

        case 18:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 12, 15, 18]]);
}
/**
 *
 * 将一个迭代器转换为对象
 * @export
 * @param {Generator} iterator 迭代器
 * @param {Function} callback 回调，返回key或者返回[key, value]
 * @returns {Object} 对象
 */


function toObject(iterator) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  var result = {};

  var _iterator3 = _createForOfIteratorHelper(iterator),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var item = _step3.value;

      var _concat = [].concat(callback(item)),
          _concat2 = (0, _slicedToArray2.default)(_concat, 2),
          key = _concat2[0],
          _concat2$ = _concat2[1],
          value = _concat2$ === void 0 ? item : _concat2$;

      result[key] = value;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return result;
}
/**
 *
 * 对一个迭代器的每一项做映射，返回映射后的带得器
 * @export
 * @param {Generator} iterator 迭代器
 * @param {Function} callback 映射回调
 * @returns {Generator} 映射后的迭代器
 */


function map(iterator, callback) {
  var _iterator4, _step4, item;

  return _regenerator.default.wrap(function map$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _iterator4 = _createForOfIteratorHelper(iterator);
          _context6.prev = 1;

          _iterator4.s();

        case 3:
          if ((_step4 = _iterator4.n()).done) {
            _context6.next = 9;
            break;
          }

          item = _step4.value;
          _context6.next = 7;
          return callback(item);

        case 7:
          _context6.next = 3;
          break;

        case 9:
          _context6.next = 14;
          break;

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](1);

          _iterator4.e(_context6.t0);

        case 14:
          _context6.prev = 14;

          _iterator4.f();

          return _context6.finish(14);

        case 17:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[1, 11, 14, 17]]);
}
/**
 *
 * 判断一个迭代器中是否有符合条件的项
 * @export
 * @param {Generator} iterator 迭代器
 * @param {Function} callback 回调
 * @returns {Boolean} 是否有符合条件的项
 */


function contains(iterator, callback) {
  var _iterator5 = _createForOfIteratorHelper(iterator),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var item = _step5.value;

      if (callback(item)) {
        return true;
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return false;
}
/**
 *
 * 判断一个迭代器中是否每一项都符合条件
 * @export
 * @param {Generator} iterator 迭代器
 * @param {Function} callback 回调
 * @returns {Boolean} 是否每一项都符合条件
 */


function every(iterator, callback) {
  var _iterator6 = _createForOfIteratorHelper(iterator),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var item = _step6.value;

      if (!callback(item)) {
        return false;
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return true;
}
/**
 *
 * 寻找迭代器中第一个有符合条件的项
 * @export
 * @param {Generator} iterator 迭代器
 * @param {Function} callback 回调
 * @returns {*} 符合条件的项
 */


function findFirst(iterator, callback) {
  var _iterator7 = _createForOfIteratorHelper(iterator),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var item = _step7.value;

      if (callback(item)) {
        return item;
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return null;
}
/**
 *
 * 寻找迭代器中第一个有符合条件的项的索引
 * @export
 * @param {Generator} iterator 迭代器
 * @param {Function} callback 回调
 * @returns {Number} 符合条件的索引，如果未有项匹配，返回-1
 */


function findFirstIndex(iterator, callback) {
  var index = 0;

  var _iterator8 = _createForOfIteratorHelper(iterator),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var item = _step8.value;

      if (callback(item)) {
        return index;
      }

      ++index;
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  return -1;
}
/**
 *
 * 寻找迭代器中最后一个符合条件的项
 * @export
 * @param {Generator} iterator 迭代器
 * @param {Function} callback 回调
 * @returns {*} 符合条件的项
 */


function findLast(iterator, callback) {
  var result = null;

  var _iterator9 = _createForOfIteratorHelper(iterator),
      _step9;

  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var item = _step9.value;

      if (callback(item)) {
        result = item;
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }

  return result;
}
/**
 *
 * 寻找迭代器中最后一个有符合条件的项的索引
 * @export
 * @param {Generator} iterator 迭代器
 * @param {Function} callback 回调
 * @returns {Number} 符合条件的索引，如果未有项匹配，返回-1
 */


function findLastIndex(iterator, callback) {
  var index = 0;
  var result = -1;

  var _iterator10 = _createForOfIteratorHelper(iterator),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var item = _step10.value;

      if (callback(item)) {
        result = index;
      }

      ++index;
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }

  return result;
}
/**
 *
 * 取生成器生成的第1个元素
 * @export
 * @param {Iterable<T>} iterator
 * @returns {T} 第一个元素
 *
 * @example
 * takeFirst(generate()); // 0
 */


function takeFirst(iterator) {
  return findFirst(iterator, function () {
    return true;
  });
}
/**
 *
 * 取生成器生成的前1个元素
 * @export
 * @param {Iterable<T>} iterator
 * @returns {T} 第一个元素
 *
 * @example
 * takeFirst(generate()); // 0
 */


function takeLast(iterator) {
  var result; // eslint-disable-next-line no-empty

  var _iterator11 = _createForOfIteratorHelper(iterator),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      result = _step11.value;
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  return result;
}
/**
 *
 * 对迭代器进行reduce操作，返回迭代器
 * @export
 * @param {Iterable<T>} iterator 迭代器
 * @param {Function} callback reducer(acc, cur, index)
 * @param {*} [initValue] 初始值，如果不设置，使用第一项作为初始值
 * @returns {Iterable<T>} 结果迭代器
 */


function reduce(iterator, callback, initValue) {
  var index, _iterator12, _step12, item;

  return _regenerator.default.wrap(function reduce$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          index = 0;
          _iterator12 = _createForOfIteratorHelper(iterator);
          _context7.prev = 2;

          _iterator12.s();

        case 4:
          if ((_step12 = _iterator12.n()).done) {
            _context7.next = 12;
            break;
          }

          item = _step12.value;

          if (initValue === undefined && index === 0) {
            initValue = item;
          } else {
            initValue = callback(initValue, item, index);
          }

          ++index;
          _context7.next = 10;
          return initValue;

        case 10:
          _context7.next = 4;
          break;

        case 12:
          _context7.next = 17;
          break;

        case 14:
          _context7.prev = 14;
          _context7.t0 = _context7["catch"](2);

          _iterator12.e(_context7.t0);

        case 17:
          _context7.prev = 17;

          _iterator12.f();

          return _context7.finish(17);

        case 20:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[2, 14, 17, 20]]);
}
/**
 *
 * 对迭代器进行reduce操作，返回左后的值
 * @export
 * @param {Iterable<T>} iterator 迭代器
 * @param {Function} callback reducer(acc, cur, index)
 * @param {*} [initValue] 初始值，如果不设置，使用第一项作为初始值
 * @returns {*} 结果
 */


function fold(iterator, callback, initValue) {
  return takeLast(reduce(iterator, callback, initValue));
}
/**
 *
 * 判断源迭代器中是否包含目标迭代器中的每一项
 * @export
 * @param {Iterable<T>} source 源迭代器
 * @param {Iterable<T>} target 目标迭代器
 * @param {(T, T)=>Boolean} [isEqual] 判断两个项是否相等
 * @returns {Boolean} 结果
 */


function containsEvery(source, target) {
  var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (lhs, rhs) {
    return lhs === rhs;
  };

  var _iterator13 = _createForOfIteratorHelper(target),
      _step13;

  try {
    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
      var i = _step13.value;
      var matched = false;

      var _iterator14 = _createForOfIteratorHelper(source),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var j = _step14.value;

          if (isEqual(j, i)) {
            matched = true;
            break;
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }

      if (!matched) {
        return false;
      }
    }
  } catch (err) {
    _iterator13.e(err);
  } finally {
    _iterator13.f();
  }

  return true;
}
/**
 *
 * 测试序列中是不是至少有1个元素通过了被提供的函数测试
 * @export
 * @param {Iterable<T>} iterator 迭代器
 * @param {Function} callback 判断函数
 * @returns {*} 结果
 */


function some(iterator, callback) {
  var _iterator15 = _createForOfIteratorHelper(iterator),
      _step15;

  try {
    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
      var item = _step15.value;

      if (callback(item)) {
        return true;
      }
    }
  } catch (err) {
    _iterator15.e(err);
  } finally {
    _iterator15.f();
  }

  return false;
}